import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { Button, InputLabel, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { APP_ICONS, APP_LOGO } from "./assets";
import AuthContainer from "./components/containers/AuthContainer";
import Loader from "./components/loader";
import TextInput from "./components/textInput";
import { constants } from "./theme/Variables";

const SupportScreen = () => {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleOpenSnackBar = (type, message) => {
    constants.snackRef.isOpenSnack({
      snackType: type,
      snackMessage: message,
    });
  };

  const handleSend = () => {
    if (!name.trim()) {
      handleOpenSnackBar("error", "Name is required");
      return;
    }
    if (!email.trim()) {
      handleOpenSnackBar("error", "Email is required");
      return;
    }
    if (!message.trim()) {
      handleOpenSnackBar("error", "Message is required");
      return;
    }

    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      handleOpenSnackBar("success", "Message to the admin successfully");
      setName("");
      setEmail("");
      setMessage("");
    }, 2000);
  };

  return (
    <AuthContainer>
      <Stack alignItems={"center"}>
        <img src={APP_LOGO.appLogo} width={177} alt="App Logo" />
      </Stack>
      <Typography
        my={2}
        fontSize={"1.5rem"}
        fontWeight={600}
        textAlign={"center"}
      >
        Welcome To BB Life Support
      </Typography>

      <Grid container rowSpacing={2} mt={4}>
        <Grid size={12}>
          <InputLabel className={"input-label"}>Name</InputLabel>
          <TextInput
            placeholder={"Full Name"}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Grid>
        <Grid size={12}>
          <InputLabel className={"input-label"}>Email</InputLabel>
          <TextInput
            placeholder={"Email"}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Grid>
        <Grid size={12}>
          <InputLabel className={"input-label"}>Message</InputLabel>
          <TextInput
            placeholder={"Type Here ..."}
            multiline={true}
            rows={3}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </Grid>
      </Grid>

      <Button
        variant="contained"
        onClick={handleSend}
        disabled={loading}
        sx={{ mt: 1, height: 45 }}
      >
        {loading ? "Sending..." : "Send"}
      </Button>

      <Loader isloading={loading} />
    </AuthContainer>
  );
};

export default SupportScreen;
